import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ObserverEmitter, { EVENTS } from '../../emitter/Observer'
import { initLoading, loadComplete } from '../../store/slices/menu/menu'

export const LoadingGiff = () => {
	const { loaded } = useSelector(state => state.menu)
	const dispatch = useDispatch()

	ObserverEmitter.on(EVENTS.loadingComplete, () => {
		dispatch(loadComplete())
	});

	ObserverEmitter.on(EVENTS.initLoading, () => {
		dispatch(initLoading())
	});

	// if (!routes.includes(location.pathname)) {
	// 	return (
	// 		<div className={`fixed z-50 w-full h-full flex justify-center items-center bg-black ${loaded && 'animate__animated  animationLoading'}`}>
	// 			<img className="w-10 h-10" src="https://i.gifer.com/origin/34/34338d26023e5515f6cc8969aa027bca_w200.gif" alt="" />
	// 		</div>
	// 	)
	// }

	return (
		<div className={`fixed z-50 w-full h-full flex justify-center items-center bg-black  ${loaded && 'animate__animated  animationLoading'}`}>
			<img className="w-10 h-10" src="https://i.gifer.com/origin/34/34338d26023e5515f6cc8969aa027bca_w200.gif" alt="" />
		</div>
	)
}
